import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Volvobusonrentinpuneforkolhapurdarshan() {



const cardData =
{
  keyword: 'Volvo Bus on Rent in Pune for Kolhapur Darshan',
  heading: 'Sanavi Travels: Volvo Bus on Rent in Pune for Kolhapur Darshan',
  headingDescription: 'Sanavi Travels offers premium Volvo Bus on Rent in Pune for Kolhapur Darshan, ideal for family pilgrims, group tours, corporate travel, and religious yatra journeys. With comfortable AC Volvo buses, trained drivers, and well-planned travel routes, we ensure a smooth, safe, and spiritually fulfilling journey from Pune to Kolhapur.',

  top: 'Popular Travel Experiences for Kolhapur Darshan from Pune',

  "topPlaces": [
    {
      "title": "Mahalakshmi Temple Darshan",
      "description": "Kolhapur Mahalakshmi Temple is one of the most revered Shakti Peethas in India and attracts thousands of devotees from Pune and across Maharashtra. Traveling by Volvo bus offers a calm and comfortable journey, allowing pilgrims to remain relaxed before darshan. Spacious seating, smooth suspension, and air-conditioned interiors make the overnight or early-morning travel peaceful, especially for senior citizens and family groups."
    },
    {
      "title": "Family Pilgrimage Tours",
      "description": "Family pilgrimage trips to Kolhapur are best planned with Volvo buses, as they allow everyone to travel together comfortably. Families benefit from ample legroom, luggage space for offerings, and a relaxed ride that reduces fatigue during long-distance travel."
    },
    {
      "title": "Group Darshan Tours",
      "description": "Group darshan tours organized by societies, bhajan mandals, or community groups require well-coordinated transportation. Volvo buses ensure disciplined group movement, timely arrivals, and a shared devotional experience throughout the journey."
    },
    {
      "title": "Corporate & Trust Organized Yatras",
      "description": "Corporate houses and religious trusts often organize Kolhapur darshan tours for employees or devotees. Volvo buses provide professional-level comfort, punctuality, and safety, ensuring a dignified travel experience."
    },
    {
      "title": "Wedding & Family Functions Travel",
      "description": "Many families visit Kolhapur for post-wedding rituals or family prayers. Hiring a Volvo bus ensures smooth group travel, allowing guests to travel together without the stress of multiple vehicles."
    },
    {
      "title": "Picnic & Leisure Trips to Kolhapur",
      "description": "Kolhapur is also known for its culture, food, and sightseeing spots. Volvo buses support comfortable leisure travel for families and groups who combine darshan with sightseeing."
    },
    {
      "title": "Tour Package Routes",
      "description": "Tour operators offering Kolhapur darshan packages prefer Volvo buses for fixed itineraries, overnight journeys, and multi-stop travel plans due to reliability and comfort."
    },
    {
      "title": "Long-Distance Overnight Travel",
      "description": "The Pune to Kolhapur route involves long-distance travel, often overnight. Volvo buses are ideal for such journeys due to reduced road vibrations, comfortable seating, and smooth highway performance."
    }
  ],

  "services": [
    {
      "name": "Volvo Bus on Rent in Pune for Kolhapur Darshan",
      "description": "Sanavi Travels provides Volvo bus rental services from Pune to Kolhapur specially designed for darshan and pilgrimage travel. These services focus on passenger comfort, safe long-distance travel, and proper scheduling to align with temple darshan timings. Volvo buses are ideal for families, senior citizens, and devotional groups seeking a peaceful and reliable journey."
    },
    {
      "name": "AC Volvo Bus for Kolhapur",
      "description": "AC Volvo buses maintain a comfortable temperature throughout the journey, ensuring passengers remain relaxed during long travel hours. This is especially beneficial for summer travel and overnight darshan trips."
    },
    {
      "name": "Non AC Volvo Bus for Kolhapur",
      "description": "Non-AC Volvo buses provide a slightly economical option while still offering superior ride quality, spacious seating, and safety features compared to regular buses."
    },
    {
      "name": "Luxury Volvo Bus Hire Kolhapur",
      "description": "Luxury Volvo buses feature premium interiors, pushback seats, and smooth suspension, making them suitable for VIP pilgrims, wedding groups, and premium tour packages."
    },
    {
      "name": "32 Seater Volvo Bus Kolhapur",
      "description": "32 seater Volvo buses are ideal for medium-sized pilgrimage groups, offering balanced seating capacity with high comfort levels."
    },
    {
      "name": "35 Seater Volvo Bus Hire Kolhapur",
      "description": "35 seater Volvo buses accommodate larger groups traveling together, ensuring everyone enjoys the same level of comfort and convenience."
    },
    {
      "name": "Volvo Bus for Family Kolhapur",
      "description": "Family-focused Volvo bus services ensure safe, comfortable, and coordinated travel for all age groups during Kolhapur darshan."
    },
    {
      "name": "Volvo Bus for Corporate Kolhapur",
      "description": "Corporate Volvo bus rentals support organized religious tours, employee trips, and trust-sponsored darshan journeys with professional standards."
    },
    {
      "name": "Volvo Bus for Group Kolhapur",
      "description": "Group Volvo bus services simplify logistics, ensure synchronized travel, and enhance the overall pilgrimage experience."
    },
    {
      "name": "Affordable Volvo Bus Rental Kolhapur",
      "description": "Affordable packages allow groups to enjoy premium Volvo travel at competitive pricing without compromising safety or comfort."
    },
    {
      "name": "Best Volvo Bus Service Kolhapur",
      "description": "Sanavi Travels is recognized for reliable Volvo bus services for Kolhapur darshan, known for punctuality and customer satisfaction."
    },
    {
      "name": "Volvo Bus with Driver Kolhapur",
      "description": "All Volvo buses come with experienced drivers familiar with Pune–Kolhapur highways and night travel safety protocols."
    },
    {
      "name": "Volvo Bus for Wedding Kolhapur",
      "description": "Wedding-related travel to Kolhapur is made comfortable and organized with Volvo buses for guests and family members."
    },
    {
      "name": "Volvo Bus for Picnic Kolhapur",
      "description": "Volvo buses are also suitable for leisure and picnic travel to Kolhapur, combining sightseeing and relaxation."
    },
    {
      "name": "Volvo Bus for Tour Packages Kolhapur",
      "description": "Tour package Volvo buses support fixed itineraries, overnight travel, and multi-location darshan plans with comfort and reliability."
    }
  ],

  "tableData": [
    ["Volvo Bus Kolhapur", "AC Volvo Bus"],
    ["Non AC Volvo Bus", "Luxury Volvo Bus"],
    ["32 Seater Volvo", "35 Seater Volvo"],
    ["Family Darshan", "Group Darshan"],
    ["Corporate Yatra", "Tour Packages"]
  ],

  "whychoose": [
    { "WhyChooseheading": "Premium Comfort Travel", "WhyChoosedescription": "Volvo buses offer superior comfort for long-distance darshan journeys." },
    { "WhyChooseheading": "Experienced Highway Drivers", "WhyChoosedescription": "Drivers trained for night and long-route travel." },
    { "WhyChooseheading": "Ideal for Pilgrimage Groups", "WhyChoosedescription": "Perfect for families, societies, and devotional groups." },
    { "WhyChooseheading": "Well-Maintained Fleet", "WhyChoosedescription": "Clean and regularly serviced Volvo buses." },
    { "WhyChooseheading": "Flexible Scheduling", "WhyChoosedescription": "Travel plans aligned with temple darshan timings." },
    { "WhyChooseheading": "Transparent Pricing", "WhyChoosedescription": "No hidden costs or surprises." },
    { "WhyChooseheading": "Safe Overnight Travel", "WhyChoosedescription": "Designed for comfortable overnight journeys." },
    { "WhyChooseheading": "Trusted Travel Partner", "WhyChoosedescription": "Sanavi Travels is a reliable name for pilgrimage transport." }
  ]
};

const faqData = [
  { question: 'Do you provide Volvo bus from Pune to Kolhapur?', answer: 'Yes, Sanavi Travels offers Volvo bus rental from Pune to Kolhapur for darshan.' },
  { question: 'Are AC Volvo buses available?', answer: 'Yes, AC Volvo buses are available for Kolhapur travel.' },
  { question: 'What seating options are available?', answer: '32 seater and 35 seater Volvo buses are available.' },
  { question: 'Is the service suitable for senior citizens?', answer: 'Yes, Volvo buses are ideal for senior citizens due to comfort.' },
  { question: 'Do you provide overnight travel?', answer: 'Yes, overnight Pune to Kolhapur travel is supported.' },
  { question: 'Is a driver included?', answer: 'Yes, all Volvo rentals include experienced drivers.' },
  { question: 'Can the bus be hired for group darshan?', answer: 'Yes, group and society darshan trips are supported.' },
  { question: 'Are buses cleaned before travel?', answer: 'Yes, all buses are cleaned and maintained regularly.' },
  { question: 'Can we include sightseeing in Kolhapur?', answer: 'Yes, sightseeing can be included in the itinerary.' },
  { question: 'How can I book Volvo bus for Kolhapur Darshan?', answer: 'You can book online or contact our support team.' }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Vinay Patil',
    feedback: 'Very comfortable Volvo bus for Kolhapur darshan. Smooth and peaceful journey.',
    rating: 5
  },
  {
    id: 2,
    name: 'Mrs. Anjali Deshmukh',
    feedback: 'Excellent service for our family Kolhapur trip. Highly recommended.',
    rating: 5
  }
];










































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];







const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Volvo Bus on Rent in Pune for Kolhapur Darshan - Sanavi Travels",
  "description": "Sanavi Travels offers Volvo buses on rent in Pune for Kolhapur Darshan trips, including family travel, corporate trips, group tours, weddings, picnics, and tour packages. AC and Non-AC 32-seater and 35-seater Volvo buses are available with professional drivers at affordable rates.",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "10000+"
  }
};





  return (
    <div>


<Helmet>
  <title>
    Call : +91 7387507373 | Volvo Bus on Rent in Pune for Kolhapur Darshan | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Book Volvo buses on rent in Pune for Kolhapur Darshan with Sanavi Travels. AC & Non-AC 32-seater and 35-seater Volvo buses for family travel, corporate trips, group tours, weddings, picnics, and tour packages with driver at best prices."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>




      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/275.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Volvobusonrentinpuneforkolhapurdarshan;